// extracted by css-extract-rspack-plugin
export default {"textContainer":"_186348af","svgIcon":"_2d31fb3c"};